import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  BodyText,
  Button,
  ListActionCollapsible,
  SPACING,
  TextField,
  useResponsive,
} from '@sweetgreen/garnish';

import { CreditMenuItem } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

export const CheckoutPaymentBlockPromoCode = ({
  promoCode,
  setPromoCode,
  onPromoCodeSubmit,
  isSubmittingPromoCode,
  hasPromoCodeError,
  onPressCreditAdd,
}: CheckoutPaymentBlockPromoCodeProps) => {
  const shouldDisableApplyBtn = promoCode.trim() === '';

  const { currentBreakpoint } = useResponsive();
  const { t } = useLocalizationContext();

  if (currentBreakpoint.isMobile)
    return (
      <CreditMenuItem
        testID="account.open-promo-code-selection-button"
        accessibilityLabel={t('account.credit.a11y-label')}
        accessibilityHint={t('account.credit.a11y-label')}
        iconName="IconPromo"
        title={t('account.credit.field-placeholder')}
        onPress={onPressCreditAdd}
      />
    );

  return (
    <ListActionCollapsible
      iconName="IconPromo"
      text={t('checkout.enter-promo-code')}
    >
      <View>
        <View style={styles.promoCodeWrapper}>
          <View style={styles.promoCodeInputWrapper}>
            <TextField
              testID="checkout.promo-code-field"
              placeholder={t('checkout.enter-promo-code')}
              clearButtonType="icon"
              value={promoCode}
              onChangeText={setPromoCode}
              clearBtnLabel={t('general.clear')}
              notice={
                hasPromoCodeError
                  ? t('account.notice.credit-invalid')
                  : undefined
              }
              invalid={hasPromoCodeError}
              noticePalette="caution"
            />
          </View>

          <Button
            style={styles.applyButton}
            testID="checkout.promo-code-button"
            palette="primary"
            disabled={shouldDisableApplyBtn}
            isLoading={isSubmittingPromoCode}
            onPress={onPromoCodeSubmit}
          >
            {t('general.apply')}
          </Button>
        </View>

        <BodyText size={4}>{t('checkout.gift-card-note')}</BodyText>
      </View>
    </ListActionCollapsible>
  );
};

const styles = StyleSheet.create({
  promoCodeWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: SPACING.medium,
  },
  promoCodeInputWrapper: {
    flexGrow: 1,
    paddingRight: SPACING.medium * 2,
    marginTop: 30,
  },
  applyButton: {
    width: 88,
  },
});

type CheckoutPaymentBlockPromoCodeProps = {
  readonly promoCode: string;
  readonly setPromoCode: (code: string) => void;
  readonly onPromoCodeSubmit: () => void;
  readonly isSubmittingPromoCode: boolean;
  readonly hasPromoCodeError: boolean;
  readonly onPressCreditAdd: () => void;
};
